/**
 * Viewユーティリティ
 */
export class ViewUtil {
  /**
   * 別タブで開く
   */
  public static openInOtherTab(url: string): void {
    window.open(url, "_blank", "noreferrer");
  }

  /**
   * 最上部へスクロールする
   */
  public static scrollToTop(): void {
    window.scrollTo(0, 0);
  }

  /**
   * スクロールYを取得する
   */
  public static getScrollY(): number {
    return window.scrollY || window.pageYOffset;
  }

  /**
   * 同じ階層の一つ前のHTML要素を取得する
   */
  public static getBeforeElement(elem: HTMLElement): HTMLElement | null {
    const parentElem: HTMLElement | null = elem.parentElement;

    if (parentElem === null) {
      return null;
    }

    const targetIndex = ViewUtil.getBeforeElementIndex(elem, parentElem);

    if (targetIndex < 0 || targetIndex > parentElem.children.length - 1) {
      return null;
    }

    return parentElem.children[targetIndex] as HTMLElement;
  }

  /**
   * 親要素内で同じ階層の一つ前のHTML要素のインデクスを取得する
   */
  private static getBeforeElementIndex(
    elem: HTMLElement,
    parentElem: HTMLElement
  ): number {
    for (let index = 0; index < parentElem.children.length; index++) {
      if (parentElem.children[index] === elem) {
        return index - 1;
      }
    }

    return -1;
  }
}
